import { Component, OnInit } from '@angular/core';
import awsconfig from './../aws-exports';
import { Auth, Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'aws-rekognition-liveness-detection-angular';
  load_face_live = false;

  // Flag to control login form visibility
  isAutoLoginInProgress = true;

  ngOnInit(): void {
    Amplify.configure(awsconfig);
    Auth.configure(awsconfig);

    /*
    Auth.currentAuthenticatedUser()
    .catch(() => {
      // Redirect to custom login page if not authenticated
      Auth.signIn("paulo.emerique@gmail.com","strongSenha")
      this.router.navigate(['/login']);
    });
    */

    Auth.signIn("paulo.emerique@gmail.com","strongSenha").then(() => {
      // Successfully signed in
      console.log('Auto sign-in success');
      this.isAutoLoginInProgress = false;
    })
    .catch(error => {
      // Auto sign-in failed, show the login form
      console.error('Auto sign-in failed:', error);
      this.isAutoLoginInProgress = false;
    });
    
    Hub.listen('auth', this.listener)
    this.load_face_live = true;
    console.log('component-loaded')
  }

  signOut(): void {
    this.load_face_live = false;
    setTimeout(() => {
      Auth.signOut();
    }, 3);
  }

  listener = (data) => {
    switch (data.payload.event) {
      case 'signIn':
        console.log('user signed in');
        this.load_face_live = true;
        // Check if the page has already reloaded
        if (!localStorage.getItem('signInReloaded')) {
          localStorage.setItem('signInReloaded', 'true');
          location.reload();
        }
        break;
    }
  };

  
}
